import Vue from 'vue';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
// import localforage from 'localforage';
// import LogRocket from 'logrocket';
import router from '@/router';
import { loadLanguageAsync } from '@/setup/i18n-setup';
import {
	pixelEvents,
	defaultStore,
	presetRangeLabel,
	newPlans,
	userIdentity,
	// userSettings,
} from '@/lib/statics';
import {
	getCurrencySymbol,
	formatMonth,
	duplicateVar,
	// isSupport,
	isLogisticSupport,
	isTester,
	isMobile,
	parseBoolean,
} from '@/lib/helper';
import client from '@/lib/http-client';
import { setCookie, removeCookie } from '@/lib/cookie';

// Chart Data Template
import {
	transactionChartDataTemplate,
	commissionChartDataTemplate,
	revenueChartDataTemplate,
	customerChartDataTemplate,
} from '@/lib/options/chart-data-template';

// Dummy Chart Data
import {
	transactionDummyChartData,
	commissionDummyChartData,
	revenueDummyChartData,
	customerDummyChartData,
} from '@/lib/options/chart-data-dummy';

// Chart Options
import {
	transactionChartOptions,
	commissionChartOptions,
	revenueChartOptions,
	customerChartOptions,
} from '@/lib/options/chart-options';

// APIs
import dashboardApi from '@/api/dashboard';
import userApi from '@/api/user';
import productsApi from '@/api/products';
import integrationApi from '@/api/integration';
import announcementsApi from '@/api/announcements';
import brandApi from '@/api/brand';
import directApi from '@/api/direct';

dayjs.extend(isSameOrBefore);
const tracker = new Vue();

const SET_DEFAULT_RESELLER_LIMIT = 'SET_DEFAULT_RESELLER_LIMIT';
const LOGIN = 'LOGIN';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILED = 'LOGIN_FAILED';
const LOGOUT = 'LOGOUT';
const SET_USER = 'SET_USER';
const SET_INTERCOM_HMAC = 'SET_INTERCOM_HMAC';
const SET_CHATWOOT_HMAC = 'SET_CHATWOOT_HMAC';
const FETCH_USER_START = 'FETCH_USER_START';
const FETCH_USER_END = 'FETCH_USER_END';
const SET_FB_AD_ACCOUNTS = 'SET_FB_AD_ACCOUNTS';
const SET_FB_CAMPAIGNS = 'SET_FB_CAMPAIGNS';
const SET_FB_CAMPAIGNS_NEXT = 'SET_FB_CAMPAIGNS_NEXT';
const SET_IS_FETCHING_AD_ACCOUNTS = 'SET_IS_FETCHING_AD_ACCOUNTS';
const SET_IS_FETCHING_CAMPAIGNS = 'SET_IS_FETCHING_CAMPAIGNS';
const RESET_FB_CAMPAIGNS_NEXT = 'RESET_FB_CAMPAIGNS_NEXT';
const ADD_BANK_ACCOUNT = 'ADD_BANK_ACCOUNT';
const REMOVE_BANK_ACCOUNT = 'REMOVE_BANK_ACCOUNT';
const ADD_IDENTITY_CARD = 'ADD_IDENTITY_CARD';
const CHANGE_STORE = 'CHANGE_STORE';
const SET_STORE_SHIPPING_PROVINCE = 'SET_STORE_SHIPPING_PROVINCE';
const SET_STORE_SHIPPING_CITY = 'SET_STORE_SHIPPING_CITY';
const SET_STORE_SHIPPING_SUBDISTRICT = 'SET_STORE_SHIPPING_SUBDISTRICT';
const SET_USERNAME = 'SET_USERNAME';
const SET_AUTO_CANCEL = 'SET_AUTO_CANCEL';
const SET_RESELLER = 'SET_RESELLER';
const SET_TRANSACTIONAL_EMAIL = 'SET_TRANSACTIONAL_EMAIL';
const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
const FETCH_NOTIFICATIONS_START = 'FETCH_NOTIFICATIONS_START';
const FETCH_NOTIFICATIONS_END = 'FETCH_NOTIFICATIONS_END';
const SET_OVERVIEW = 'SET_OVERVIEW';
const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';
const SET_NOTICE_PUBLIC = 'SET_NOTICE_PUBLIC';
const TOGGLE_ANNOUNCEMENTS = 'TOGGLE_ANNOUNCEMENTS';
const SET_SETTINGS = 'SET_SETTINGS';
const SET_NOTICE = 'SET_NOTICE';
const DISMISS_NOTICE = 'DISMISS_NOTICE';
const SET_EMBED_VERSION = 'SET_EMBED_VERSION';
const SET_STOREFRONT_STATUS = 'SET_STOREFRONT_STATUS';
const SET_LOGO_DATA = 'SET_LOGO_DATA';
const SET_BILLINGS_COUNT = 'SET_BILLINGS_COUNT';
const SET_BILLINGS_DUE_COUNT = 'SET_BILLINGS_DUE_COUNT';
const SET_BLACKLISTED_PRDOUCT_IDS = 'SET_BLACKLISTED_PRDOUCT_IDS';
const SET_GOOGLE_ANALYTICS_KEY = 'SET_GOOGLE_ANALYTICS_KEY';
const SET_META_PIXELS = 'SET_META_PIXELS';
const SET_LIMITED_STOCK_PRODUCTS_IDS = 'SET_LIMITED_STOCK_PRODUCTS_IDS';
const SET_RANGE_STOCK_CHECKED_PRODUCTS_COUNT = 'SET_RANGE_STOCK_CHECKED_PRODUCTS_COUNT';
const SET_STOCK_CHECKED_PRODUCTS_COUNT = 'SET_STOCK_CHECKED_PRODUCTS_COUNT';
const SET_FULL_WIDTH = 'SET_FULL_WIDTH';
const SET_CUSTOM_DOMAINS = 'SET_CUSTOM_DOMAINS';
const SET_CAPABILITIES = 'SET_CAPABILITIES';
const SET_HIGH_DEMAND_PAGINATION = 'SET_HIGH_DEMAND_PAGINATION';
const IS_SHOW_ALL_HIGH_DEMAND_PRODUCT = 'IS_SHOW_ALL_HIGH_DEMAND_PRODUCT';
const SET_CANCELLED_SUBMISSIONS_IDS = 'SET_CANCELLED_SUBMISSIONS_IDS';
// const SET_OO_TOKEN = 'SET_OO_TOKEN';

const defaultCurrency = 'IDR';

const defaultPixelEvents = duplicateVar(pixelEvents);

const sessionCookieName = 'oo_user';
const domain = 'ostock.id';

// Get Announcements
const getAnnouncements = (params, callback) => {
	const defaultParams = {
		sort_by: 'created_at',
		sort: 'desc',
		limit: 25,
		page: 1,
	};
	const requestParams = Object.assign({}, defaultParams, params);
	announcementsApi.getList(requestParams, callback);
};

// Update Settings
const updateSettings = (settings) => {
	const callback = (response) => {
		this.setSettings(response.data.settings);
	};
	userApi.updateSettings(settings, callback);
	// const localSettings = duplicateVar(settings);
	// if (localSettings.stock) delete localSettings.stock;
	// localforage.setItem('settings', localSettings);
};

const state = function () {
	return {
		capabilities: [],
		commission: 5,
		location: '/',
		user: false,
		isFetchingUser: false,
		locale: 'en',
		isLoggedIn: !!localStorage.getItem('token'),
		isOoLoggedIn: !!localStorage.getItem('oo_token'),
		intercomHmac: localStorage.getItem('in_hmac'),
		chatwootHmac: localStorage.getItem('chatwoot_hmac'),
		loginError: false,
		pending: false,
		// settings: duplicateVar(userSettings),
		settings: null,
		overview: {
			submission_count: 0,
			transaction_count: 0,
			bump_count: 0,
			paid_ratio: 0,
			bump_revenue: 0,
			coupon_discount_claimed: 0,
			gross_revenue: 0,
			net_revenue: 0,
			gross_profit: 0,
		},
		followUpConversionStatistic: {
			0: 0,
			1: 0,
			2: 0,
			3: 0,
			4: 0,
			5: 0,
			6: 0,
			7: 0,
			8: 0,
		},
		trackingStatistic: [],
		dailyStatistic: [],
		transactionChartOptions,
		commissionChartOptions,
		revenueChartOptions,
		customerChartOptions,
		profitableProducts: [],
		highDemandProducts: [],
		isShowAllHighDemandProduct: false,
		highDemandProductsPagination: {
			current_page: 1,
			last_page: 1,
			total_all_products: 0,
			total_paid_order: 0,
			total_products: 0,
			total_quantity_sold: 0,
		},
		highConvertingProducts: [],
		transactionChartData: transactionDummyChartData,
		commissionChartData: commissionDummyChartData,
		revenueChartData: revenueDummyChartData,
		customerChartData: customerDummyChartData,
		pixelEvents: defaultPixelEvents,
		presetRangeLabel,
		fbAdAccounts: [],
		fbCampaigns: [],
		fbCampaignNext: '',
		isFetchingAdAccount: false,
		isFetchingCampaigns: false,
		announcements: [],
		isRightbarVisible: false,
		isSocketConnected: false,
		notice: [],
		noticePublics: [],
		embedVersion: process.env.VUE_APP_EMBED_VERSION,
		isStorefrontActive: false,
		appName: process.env.VUE_APP_NAME,
		appLogo: process.env.VUE_APP_LOGO,
		appProject: process.env.VUE_APP_PROJECT,
		logoData: '',
		billingsCount: 0,
		billingsDueCount: 0,
		blacklistedProductIds: [],
		googleAnalyticsKey: '',
		metaPixels: [],
		isFullWidth: false,
		customDomains: [],
		ooWeb: process.env.VUE_APP_OO_WEB || 'https://app.orderonline.id',
		ooApi: process.env.VUE_APP_OO_API || 'https://api.orderonline.id',
		isSidebarShow: true,
		limitedStockProductIds: [],
		rangeStockCheckedProductsCount: [],
		stockCheckedProductsCount: 0,
		cancelledSubmissionIds: [],
		isGoogleRecaptchaEnabled: process.env.VUE_APP_GOOGLE_RECAPTCHA_ENABLED || true,
	};
};

const mutations = {
	[SET_DEFAULT_RESELLER_LIMIT](state, val) {
		state.user.credit.reseller = val;
	},
	[LOGIN](state) {
		state.pending = true;
	},
	[LOGIN_SUCCESS](state) {
		state.isLoggedIn = true;
		state.loginError = false;
		state.pending = false;
	},
	[LOGIN_FAILED](state, errorMessage) {
		state.loginError = errorMessage;
		state.pending = false;
	},
	[LOGOUT](state) {
		state.user = false;
		state.isLoggedIn = false;
		state.fbAdAccounts = [];
	},
	[FETCH_USER_START](state) {
		state.isFetchingUser = true;
	},
	[FETCH_USER_END](state) {
		state.isFetchingUser = false;
	},
	[SET_USER](state, user) {
		const currentUser = state.user ? state.user : {};
		const newUser = Object.assign({}, currentUser, user);
		state.user = newUser;
		if (newUser.locale) {
			state.locale = newUser.locale;
			loadLanguageAsync(newUser.locale);
		}
		if (newUser.settings) {
			// state.settings = user.settings;
			const defaultSettings = duplicateVar(state.settings);
			const userSettings = Object.assign({}, defaultSettings, newUser.settings);
			state.settings = userSettings;
		}

		if (newUser.commission) {
			state.commission = newUser.commission;
		}

		if (newUser.oo_token) {
			const ooToken = newUser.oo_token;
			if (ooToken) {
				localStorage.setItem('oo_token', ooToken);
				state.isOoLoggedIn = ooToken;
			}
		}

		if (newUser.hmac) {
			localStorage.setItem('in_hmac', newUser.hmac);
			state.intercomHmac = newUser.hmac;
		}

		if (newUser.chatwoot_hmac) {
			localStorage.setItem('chatwoot_hmac', newUser.chatwoot_hmac);
			state.chatwootHmac = newUser.chatwoot_hmac;
		}

		// Identify LogRocket
		// const userData = {
		// 	name: user.name,
		// 	email: user.email,
		// 	// Custom
		// 	role: user.role,
		// 	subscriptionType: user.package,
		// };
		// LogRocket.identify(user._id, userData);
	},
	[FETCH_NOTIFICATIONS_START](state) {
		state.isFetchingNotifications = true;
	},
	[FETCH_NOTIFICATIONS_END](state) {
		state.isFetchingNotifications = false;
	},
	navigate(state, to) {
		state.location = to;
	},
	setLocale(state, locale) {
		state.locale = locale;
	},
	[SET_OVERVIEW](state, overview) {
		state.overview = overview;
	},
	setFollowUpConversionStatistic(state, followUpConversionStatistic) {
		state.followUpConversionStatistic = followUpConversionStatistic;
	},
	setTrackingStatistic(state, trackingStatistic) {
		state.trackingStatistic = trackingStatistic;
	},
	setDailyStatistic(state, dailyStatistic) {
		state.dailyStatistic = dailyStatistic;
	},
	setTransactionChartData(state, transactionChartData) {
		state.transactionChartData = transactionChartData;
	},
	setCommissionChartData(state, commissionChartData) {
		state.commissionChartData = commissionChartData;
	},
	setRevenueChartData(state, revenueChartData) {
		state.revenueChartData = revenueChartData;
	},
	setCustomerChartData(state, customerChartData) {
		state.customerChartData = customerChartData;
	},
	setProfitableProducts(state, products) {
		state.profitableProducts = products;
	},
	setHighConvertingProducts(state, products) {
		state.highConvertingProducts = products;
	},
	[IS_SHOW_ALL_HIGH_DEMAND_PRODUCT](state, val) {
		state.isShowAllHighDemandProduct = val;
	},
	setHighDemandProducts(state, products) {
		state.highDemandProducts = products;
	},
	[SET_HIGH_DEMAND_PAGINATION](state, pagination) {
		state.highDemandProductsPagination = pagination;
	},
	[SET_FB_AD_ACCOUNTS](state, fbAdAccounts) {
		state.fbAdAccounts = fbAdAccounts;
	},
	[SET_FB_CAMPAIGNS](state, fbCampaigns) {
		// state.fbCampaigns = fbCampaigns;
		state.fbCampaigns = state.fbCampaigns.concat(fbCampaigns);
	},
	[SET_FB_CAMPAIGNS_NEXT](state, next) {
		state.fbCampaignNext = next;
	},
	[RESET_FB_CAMPAIGNS_NEXT](state) {
		state.fbCampaigns = [];
		state.fbCampaignNext = '';
	},
	[SET_IS_FETCHING_AD_ACCOUNTS](state, isFetching) {
		state.isFetchingAdAccount = isFetching;
	},
	[SET_IS_FETCHING_CAMPAIGNS](state, isFetching) {
		state.isFetchingCampaigns = isFetching;
	},
	[ADD_BANK_ACCOUNT](state, bankAccount) {
		if (state.user) {
			state.user.bank_accounts.push(bankAccount);
		}
	},
	[REMOVE_BANK_ACCOUNT](state, index) {
		if (state.user) {
			state.user.bank_accounts.splice(index, 1);
		}
	},
	[ADD_IDENTITY_CARD](state, identity) {
		if (state.user) {
			state.user.identity = identity;
		}
	},
	[CHANGE_STORE](state, store) {
		if (store.apply_to_all) {
			delete store.apply_to_all;
		}
		if (state.user) {
			state.user.store = store;
		}
	},
	[SET_STORE_SHIPPING_PROVINCE](state, province) {
		state.user.store.shipping.origin.province = province;
	},
	[SET_STORE_SHIPPING_CITY](state, city) {
		state.user.store.shipping.origin.city = city;
	},
	[SET_STORE_SHIPPING_SUBDISTRICT](state, subdistrict) {
		state.user.store.shipping.origin.subdistrict = subdistrict;
	},
	[SET_USERNAME](state, username) {
		state.user.username = username;
	},
	[SET_AUTO_CANCEL](state, autoCancel) {
		state.user.auto_cancel_order = autoCancel;
	},
	[SET_RESELLER](state, reseller) {
		state.user.reseller = reseller;
	},
	[SET_TRANSACTIONAL_EMAIL](state, transactionalEmail) {
		state.user.transactional_email = transactionalEmail;
	},
	[SET_ANNOUNCEMENTS](state, announcements) {
		state.announcements = announcements;
	},
	[TOGGLE_ANNOUNCEMENTS](state, value) {
		state.isRightbarVisible = value || !state.isRightbarVisible;
		if (state.isRightbarVisible) {
			// Update local data
			const newSettings = duplicateVar(state.settings);
			if (newSettings.ui.lastOpenedAnnouncements) {
				delete newSettings.ui.lastOpenedAnnouncements;
			}
			// Update UI State
			newSettings.ui.last_opened_announcements = new Date().toISOString();
			state.settings = newSettings;
			updateSettings(newSettings);
		}
	},
	[SET_SETTINGS](state, settings) {
		state.settings = settings;
	},
	[SET_NOTICE](state, notice) {
		state.notice = notice;
	},
	[SET_NOTICE_PUBLIC](state, announcements) {
		state.noticePublics = announcements;
	},
	[DISMISS_NOTICE](state, type) {
		// Update local data
		const newSettings = duplicateVar(state.settings);
		// Update UI State
		if (type === 'public') {
			newSettings.ui.last_dismissed_notice = new Date().toISOString();
		} else {
			newSettings.ui.last_dismissed_notice_role = new Date().toISOString();
		}
		state.settings = newSettings;
		updateSettings(newSettings);
	},
	[SET_EMBED_VERSION](state, version) {
		state.embedVersion = version;
	},
	[SET_STOREFRONT_STATUS](state, status) {
		state.isStorefrontActive = status;
	},
	[SET_LOGO_DATA](state, logoData) {
		state.logoData = logoData;
	},
	[SET_BILLINGS_COUNT](state, billingsCount) {
		state.billingsCount = billingsCount;
	},
	[SET_BILLINGS_DUE_COUNT](state, billingsDueCount) {
		state.billingsDueCount = billingsDueCount;
	},
	[SET_BLACKLISTED_PRDOUCT_IDS](state, blacklistedProductIds) {
		state.blacklistedProductIds = blacklistedProductIds;
	},
	[SET_GOOGLE_ANALYTICS_KEY](state, googleAnalyticsKey) {
		state.googleAnalyticsKey = googleAnalyticsKey;
	},
	[SET_META_PIXELS](state, metaPixels) {
		state.metaPixels = metaPixels;
	},
	[SET_LIMITED_STOCK_PRODUCTS_IDS](state, limitedStockProductIds) {
		state.limitedStockProductIds = limitedStockProductIds;
	},
	[SET_RANGE_STOCK_CHECKED_PRODUCTS_COUNT](state, rangeStockCheckedProductsCount) {
		state.rangeStockCheckedProductsCount = rangeStockCheckedProductsCount;
	},
	[SET_STOCK_CHECKED_PRODUCTS_COUNT](state, stockCheckedProductsCount) {
		state.stockCheckedProductsCount = stockCheckedProductsCount;
	},
	[SET_CANCELLED_SUBMISSIONS_IDS](state, cancelledSubmissionIds) {
		state.cancelledSubmissionIds = cancelledSubmissionIds;
	},
	[SET_FULL_WIDTH](state, isFullWidth) {
		state.isFullWidth = isFullWidth;
	},
	[SET_CUSTOM_DOMAINS](state, domains) {
		state.customDomains = domains;
	},
	[SET_CAPABILITIES](state, capabilities) {
		state.capabilities = capabilities;
	},
	[SET_INTERCOM_HMAC](state, hmac) {
		state.intercomHmac = hmac;
	},
	[SET_CHATWOOT_HMAC](state, hmac) {
		state.chatwootHmac = hmac;
	},
	SOCKET_CONNECT(state) {
		state.isSocketConnected = true;
	},
	SOCKET_ANNOUNCEMENT_ADD(state, value) {
		state.announcements.push(value);

		// Set Notice
		if (value.type === 'notice' && value.visibility === 'public') {
			state.noticePublics = [];
			state.noticePublics.push(value);
		} else {
			state.notice = [];
			state.notice.push(value);
		}
	},
	SOCKET_ANNOUNCEMENT_UPDATE(state, value) {
		const index = state.announcements.findIndex(({ _id }) => _id === value._id);
		if (index !== -1) {
			state.announcements[index] = value;
		}

		// Update Notice
		if (value.type === 'notice' && value.visibility === 'public') {
			state.noticePublics = [];
		} else {
			state.notice = [];
		}
	},
	setToggleSidebar(state, data) {
		state.isSidebarShow = data;
	},
};

const actions = {
	popUpLogin({ commit }, { creds, redirectPath }) {
		commit(LOGIN); // show spinner
		const authCallback = function (response) {
			const jwt = response.data.access_token;
			const ooToken = response.data.oo_token;
			const intercomHmac = response.data.hmac;
			const chatwootHmac = response.data.chatwoot_hmac;
			const capabilities = response.data.capabilities;
			const isAdmin = response.data.is_admin;
			const role = response.data.role;
			const loginType = (isAdmin && role !== 'owner') ? 'admin' : 'member';

			if (ooToken) {
				localStorage.setItem('oo_token', ooToken);
			}

			if (intercomHmac) {
				localStorage.setItem('in_hmac', intercomHmac);
			}

			if (chatwootHmac) {
				localStorage.setItem('chatwoot_hmac', chatwootHmac);
			}

			localStorage.setItem('token', jwt);
			client.defaults.headers.Authorization = `Bearer ${jwt}`;

			// Track
			tracker.$gtm.trackEvent({
				event: null, // Event type [default = 'interaction'] (Optional)
				category: 'Auth',
				action: 'request',
				label: 'Login Success',
				value: creds.email,
				noninteraction: true, // Optional
			});

			commit(SET_CAPABILITIES, capabilities);
			commit(SET_INTERCOM_HMAC, intercomHmac);
			commit(LOGIN_SUCCESS);

			brandApi.resendBrand();

			directApi.resendDirect();

			if (redirectPath && redirectPath !== '') {
				window.location.href = redirectPath;
			} else {
				switch (loginType) {
				case 'admin':
					window.location.href = '/admin';
					break;
				default:
					window.location.href = '/';
					break;
				}
			}
		};
		const authErrorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
			const response = e.response ? e.response.data : false;
			const message = response ? response.message : '';

			// Track
			tracker.$gtm.trackEvent({
				event: null, // Event type [default = 'interaction'] (Optional)
				category: 'Auth',
				action: 'request',
				label: 'Login Failed',
				value: creds.email,
				noninteraction: true, // Optional
			});

			commit(LOGIN_FAILED, message);
		};
		// Post Auth Dropshipper Only
		userApi.authDropshipper(creds, authCallback, authErrorCallback);
	},
	login({ commit }, { creds, redirectPath }) {
		commit(LOGIN); // show spinner
		const authCallback = function (response) {
			const jwt = response.data.access_token;
			const ooToken = response.data.oo_token;
			const intercomHmac = response.data.hmac;
			const chatwootHmac = response.data.chatwoot_hmac;
			const capabilities = response.data.capabilities;
			const isAdmin = response.data.is_admin;
			const role = response.data.role;
			console.log(role);
			const loginType = (isAdmin && role !== 'owner') ? 'admin' : 'member';

			if (ooToken) {
				localStorage.setItem('oo_token', ooToken);
			}

			if (intercomHmac) {
				localStorage.setItem('in_hmac', intercomHmac);
			}

			if (chatwootHmac) {
				localStorage.setItem('chatwoot_hmac', chatwootHmac);
			}

			localStorage.setItem('token', jwt);
			client.defaults.headers.Authorization = `Bearer ${jwt}`;

			// Track
			tracker.$gtm.trackEvent({
				event: null, // Event type [default = 'interaction'] (Optional)
				category: 'Auth',
				action: 'request',
				label: 'Login Success',
				value: creds.email,
				noninteraction: true, // Optional
			});

			commit(SET_CAPABILITIES, capabilities);
			commit(SET_INTERCOM_HMAC, intercomHmac);
			commit(LOGIN_SUCCESS);
			if (redirectPath && redirectPath !== '') {
				// router.push(redirectPath);
				window.location.href = redirectPath;
			} else {
				// router.push('/');
				switch (loginType) {
				case 'admin':
					// router.push('/admin');
					window.location.href = '/admin';
					break;
				default:
					window.location.href = '/';
					break;
				}
			}
		};
		const authErrorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
			const response = e.response ? e.response.data : false;
			const message = response ? response.message : '';

			// Track
			tracker.$gtm.trackEvent({
				event: null, // Event type [default = 'interaction'] (Optional)
				category: 'Auth',
				action: 'request',
				label: 'Login Failed',
				value: creds.email,
				noninteraction: true, // Optional
			});

			commit(LOGIN_FAILED, message);
		};
		// Post Auth
		userApi.auth(creds, authCallback, authErrorCallback);
	},
	loginWithOO({ commit }, { creds, redirectPath }) {
		commit(LOGIN); // show spinner
		const authCallback = function (response) {
			const jwt = response.data.access_token;
			const ooToken = response.data.oo_token;
			const intercomHmac = response.data.hmac;
			const chatwootHmac = response.data.chatwoot_hmac;
			const capabilities = response.data.capabilities;
			// console.log(ooToken);
			if (ooToken) {
				localStorage.setItem('oo_token', ooToken);
			}

			if (intercomHmac) {
				localStorage.setItem('in_hmac', intercomHmac);
			}

			if (chatwootHmac) {
				localStorage.setItem('chatwoot_hmac', chatwootHmac);
			}

			localStorage.setItem('token', jwt);
			client.defaults.headers.Authorization = `Bearer ${jwt}`;

			// Track
			// tracker.$gtm.trackEvent({
			// 	event: null, // Event type [default = 'interaction'] (Optional)
			// 	category: 'Auth',
			// 	action: 'request',
			// 	label: 'Login Success',
			// 	value: creds.email,
			// 	noninteraction: true, // Optional
			// });

			commit(SET_CAPABILITIES, capabilities);
			commit(SET_INTERCOM_HMAC, intercomHmac);
			commit(LOGIN_SUCCESS);

			brandApi.resendBrand();

			directApi.resendDirect();

			if (redirectPath && redirectPath !== '') {
				// router.push(redirectPath);
				window.location.href = redirectPath;
			} else {
				// router.push('/');
				window.location.href = '/';
			}
		};
		const authErrorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
			const response = e.response ? e.response.data : false;
			const message = response ? response.message : '';

			// Track
			// tracker.$gtm.trackEvent({
			// 	event: null, // Event type [default = 'interaction'] (Optional)
			// 	category: 'Auth',
			// 	action: 'request',
			// 	label: 'Login Failed',
			// 	value: creds.email,
			// 	noninteraction: true, // Optional
			// });

			commit(LOGIN_FAILED, message);
		};
		// Post Auth
		userApi.authWithOO(creds, authCallback, authErrorCallback);
	},
	loginWithConnectionToken({ commit }, { creds, redirectPath }) {
		commit(LOGIN); // show spinner
		const authCallback = function (response) {
			const jwt = response.data.access_token;
			const ooToken = response.data.oo_token;
			const intercomHmac = response.data.hmac;
			const chatwootHmac = response.data.chatwoot_hmac;
			const capabilities = response.data.capabilities;
			// console.log(ooToken);
			if (ooToken) {
				localStorage.setItem('oo_token', ooToken);
			}

			if (intercomHmac) {
				localStorage.setItem('in_hmac', intercomHmac);
			}

			if (chatwootHmac) {
				localStorage.setItem('chatwoot_hmac', chatwootHmac);
			}

			localStorage.setItem('token', jwt);
			client.defaults.headers.Authorization = `Bearer ${jwt}`;

			commit(SET_CAPABILITIES, capabilities);
			commit(SET_INTERCOM_HMAC, intercomHmac);
			commit(LOGIN_SUCCESS);
			if (redirectPath && redirectPath !== '') {
				// router.push(redirectPath);
				window.location.href = redirectPath;
			} else {
				// router.push('/');
				window.location.href = '/';
			}
		};
		const authErrorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
			const response = e.response ? e.response.data : false;
			const message = response ? response.message : '';

			commit(LOGIN_FAILED, message);
		};
		// Post Auth
		userApi.authWithConnectionToken(creds, authCallback, authErrorCallback);
	},
	logout({ commit, state }) {
		// Track
		tracker.$gtm.trackEvent({
			event: null, // Event type [default = 'interaction'] (Optional)
			category: 'Auth',
			action: 'request',
			label: 'Logout',
			value: state.user.email,
			noninteraction: true, // Optional
		});

		const callback = () => {
			localStorage.removeItem('token');
			localStorage.removeItem('oo_token');
			localStorage.removeItem('in_hmac');
			localStorage.removeItem('chatwoot_hmac');
			delete client.defaults.headers.Authorization;

			if (window.$chatwoot) {
				window.$chatwoot.reset();
			}

			commit(LOGOUT);
			removeCookie(sessionCookieName);

			router.go();
		};

		// Logout on API
		userApi.logout(callback);

		// commit(LOGOUT);
		// removeCookie(sessionCookieName);
		// router.push('/');
		// router.go();
	},
	navigate({ commit }, to) {
		commit('navigate', to);
	},
	setUser({ commit }, user) {
		commit(SET_USER, user);
	},
	fetchUser({ commit, state }, setUserCookie = true) {
		if (!this.isFetchingUser) {
			commit(FETCH_USER_START);
			const callback = function (response) {
				const user = response.data;
				commit(FETCH_USER_END);
				commit(SET_USER, user);

				if (user && setUserCookie) {
					setCookie(sessionCookieName, user._id, 30, domain);
				}

				try {
					if (!state.user.is_admin) {
						if ((user.bank_accounts.length === 0 || (state.user.identity.status !== 'approved'))) {
							router.push('/welcome');
						}
					}
				} catch (error) { console.log(error); }
			};
			const errorCallback = function (e) {
				commit(FETCH_USER_END);
				// eslint-disable-next-line
				console.log(e);
			};
			userApi.getProfile(callback, errorCallback);
		}
	},
	fetchStatistic({ commit }, params) {
		const callback = function (response) {
			const overview = response.data;
			// Calculate Gross Profit
			const grossProfit = overview.net_revenue - overview.cogs;
			// Calculate Net Profit
			const netProfit = grossProfit - overview.expense;

			overview.gross_profit = grossProfit;
			overview.net_profit = netProfit;

			commit(SET_OVERVIEW, overview);
		};
		const errorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
		};
		dashboardApi.getStatistic(params, callback, errorCallback);
	},
	fetchFollowUpConversionStatistic({ commit }, params) {
		const callback = function (response) {
			commit('setFollowUpConversionStatistic', response.data);
		};
		const errorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
		};
		dashboardApi.getFollowUpConversionStatistic(
			params,
			callback,
			errorCallback,
		);
	},
	fetchTrackingStatistic({ commit }, params) {
		const callback = function (response) {
			commit('setTrackingStatistic', response.data);
		};
		const errorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
		};
		dashboardApi.getTrackingStatistic(params, callback, errorCallback);
	},
	fetchDailyStatistic({ commit }, params) {
		const dupParams = duplicateVar(params);
		const callback = (response) => {
			const dailyStatistic = response.data;
			// const dailyStatisticDate = dailyStatistic.map(item => item.date);
			const dailyStatisticDate = dailyStatistic.map(
				item => `${item._id.day} ${formatMonth(item._id.month)}`,
			);
			commit('setDailyStatistic', dailyStatistic);

			const transactionChartData = JSON.parse(
				JSON.stringify(transactionChartDataTemplate),
			);
			transactionChartData.chartId = 'transaction';
			transactionChartData.datasets[0].data = dailyStatistic.map(
				item => item.transaction_count,
			);
			transactionChartData.datasets[1].data = dailyStatistic.map(
				item => item.submission_count,
			);
			transactionChartData.labels = dailyStatisticDate;
			commit('setTransactionChartData', transactionChartData);

			const revenueChartData = JSON.parse(
				JSON.stringify(revenueChartDataTemplate),
			);
			revenueChartData.chartId = 'revenue';
			revenueChartData.datasets[0].data = dailyStatistic.map(
				item => item.net_revenue,
			);
			revenueChartData.labels = dailyStatisticDate;
			commit('setRevenueChartData', revenueChartData);

			const commissionChartData = JSON.parse(
				JSON.stringify(commissionChartDataTemplate),
			);
			const chartId = dupParams?.type ?? 'commission';
			commissionChartData.chartId = chartId;
			commissionChartData.datasets[0].data = dailyStatistic.map(
				item => item[chartId],
			);
			commissionChartData.datasets[0].label = dupParams?.textType;

			commissionChartData.labels = dailyStatisticDate;
			commit('setCommissionChartData', commissionChartData);
		};
		const errorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
		};

		delete params.textType;
		delete params.type;
		dashboardApi.getDailyStatistic(params, callback, errorCallback);
	},
	setCommissionChartData({ commit }, commissionChartData) {
		commit('setCommissionChartData', commissionChartData);
	},
	fetchCustomerStatistic({ commit }, params) {
		const callback = (response) => {
			const customerStatistic = response.data;
			const customerAllCities = [];
			const customerCities = [];
			const customerCitiesCounts = [];
			const totalCustomers = customerStatistic.reduce(
				(prev, { count }) => prev + count,
				0,
			);

			for (let i = 0; i <= customerStatistic.length; i++) {
				if (customerStatistic[i] !== undefined) {
					const item = customerStatistic[i];
					const location = item.city || '- Unknown Location -';
					const percentage = parseFloat(
						(item.count / totalCustomers) * 100,
					).toFixed(2);
					if (i < 10) {
						customerCities.push(`${location} (${item.count}) - ${percentage}%`);
						customerCitiesCounts.push(item.count);
					}
					customerAllCities.push({ name: location, count: item.count });
				}
			}

			const customerChartData = JSON.parse(
				JSON.stringify(customerChartDataTemplate),
			);
			customerChartData.chartId = 'customer';
			customerChartData.allCities = customerAllCities;
			customerChartData.datasets[0].data = customerCitiesCounts;
			customerChartData.labels = customerCities;
			commit('setCustomerChartData', customerChartData);
		};
		const errorCallback = function (e) {
			// eslint-disable-next-line
			console.log(e);
		};
		dashboardApi.getCustomerStatistic(params, callback, errorCallback);
	},
	fetchFeaturedProducts({ commit }, params) {
		const callback = (response) => {
			const products = response.data.products;
			const pagination = response.data.page_info;
			commit(params.commitName, products);
			commit(SET_HIGH_DEMAND_PAGINATION, pagination);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
		};
		productsApi.getProducts(params.query, callback, errorCallback);
	},
	fetchAnnouncements({ commit }, params) {
		const callback = (response) => {
			const announcements = response.data;
			commit(SET_ANNOUNCEMENTS, announcements);
		};
		getAnnouncements(params, callback);
	},
	fetchNotice(
		{ commit },
		params = { type: 'notice', limit: 1, is_active: true },
	) {
		const callback = (response) => {
			const notices = response.data;
			if (notices.length > 0) {
				const notice = notices;
				if (notices[0].visibility === 'public') {
					commit(SET_NOTICE_PUBLIC, notice);
				} else {
					commit(SET_NOTICE, notice);
				}
			}
		};
		getAnnouncements(params, callback);
	},
	fetchFBAdAccounts({ commit }) {
		commit(SET_IS_FETCHING_AD_ACCOUNTS, true);
		const callback = (response) => {
			const fbAdAccounts = response.data;
			commit(SET_FB_AD_ACCOUNTS, fbAdAccounts);
			commit(SET_IS_FETCHING_AD_ACCOUNTS, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING_AD_ACCOUNTS, false);
		};
		integrationApi.getFBAdAccounts(callback, errorCallback);
	},
	fetchFBCampaigns({ commit }, params) {
		commit(SET_IS_FETCHING_CAMPAIGNS, true);
		const callback = (response) => {
			const campaigns = response.data.campaigns;
			const nextPage = response.data.next;
			commit(SET_FB_CAMPAIGNS, campaigns);
			commit(SET_FB_CAMPAIGNS_NEXT, nextPage);
			commit(SET_IS_FETCHING_CAMPAIGNS, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING_CAMPAIGNS, false);
		};
		integrationApi.getFBCampaign(params, callback, errorCallback);
	},
	resetFBCampaignsNext({ commit }) {
		commit(RESET_FB_CAMPAIGNS_NEXT);
	},
	addBankAccountWithOtp({ commit, state }, { params, cb, errorCb }) {
		const bankAccount = params.bank_account;
		const bankAccounts = duplicateVar(state.user.bank_accounts);
		bankAccounts.push(bankAccount);
		const callback = () => {
			commit(ADD_BANK_ACCOUNT, bankAccount);
			cb();
		};
		const errorCallback = (e) => {
			errorCb(e);
		};
		userApi.addBankAccountWithOtp(params, callback, errorCallback);
	},
	addBankAccount({ commit, state }, { bankAccount, cb, errorCb }) {
		const bankAccounts = duplicateVar(state.user.bank_accounts);
		bankAccounts.push(bankAccount);
		const callback = () => {
			commit(ADD_BANK_ACCOUNT, bankAccount);
			cb();
		};
		const errorCallback = () => {
			errorCb();
		};
		userApi.updateBankAccounts(bankAccounts, callback, errorCallback);
	},
	removeBankAccount({ commit, state }, { index, cb, errorCb }) {
		const bankAccounts = duplicateVar(state.user.bank_accounts);
		bankAccounts.splice(index, 1);
		const callback = () => {
			commit(REMOVE_BANK_ACCOUNT, index);
			cb();
		};
		const errorCallback = () => {
			errorCb();
		};
		userApi.updateBankAccounts(bankAccounts, callback, errorCallback);
	},
	addIdentityCard({ commit }, { identity, cb, errorCb }) {
		const callback = () => {
			commit(ADD_IDENTITY_CARD, identity);
			cb();
		};
		const errorCallback = () => {
			errorCb();
		};
		console.log('vuex', identity);
		userApi.updateIdentityCard(identity, callback, errorCallback);
	},
	updateStore({ commit }, { store, cb, errorCb }) {
		const callback = () => {
			commit(CHANGE_STORE, store);
			cb();
		};
		const errorCallback = () => {
			errorCb();
		};
		userApi.updateStore(store, callback, errorCallback);
	},
	isShowAllHighDemandProduct({ commit }, status) {
		commit(IS_SHOW_ALL_HIGH_DEMAND_PRODUCT, status);
	},
	setStoreShippingProvince({ commit }, province) {
		commit(SET_STORE_SHIPPING_PROVINCE, province);
	},
	setStoreShippingCity({ commit }, city) {
		commit(SET_STORE_SHIPPING_CITY, city);
	},
	setStoreShippingSubdistrict({ commit }, subdistrict) {
		commit(SET_STORE_SHIPPING_SUBDISTRICT, subdistrict);
	},
	setUsername({ commit }, username) {
		commit(SET_USERNAME, username);
	},
	setAutoCancel({ commit }, autoCancel) {
		commit(SET_AUTO_CANCEL, autoCancel);
	},
	setReseller({ commit }, reseller) {
		commit(SET_RESELLER, reseller);
	},
	setTransactionalEmail({ commit }, transactionalEmail) {
		commit(SET_TRANSACTIONAL_EMAIL, transactionalEmail);
	},
	setNotifications({ commit }, notifications) {
		commit(SET_NOTIFICATIONS, notifications);
	},
	toggleAnnouncements({ commit }, value) {
		commit(TOGGLE_ANNOUNCEMENTS, value);
	},
	setSettings({ commit }, settings) {
		commit(SET_SETTINGS, settings);
	},
	setNotice({ commit }, notice) {
		commit(SET_NOTICE, notice);
	},
	dismissNotice({ commit }, type) {
		commit(DISMISS_NOTICE, type);
	},
	setEmbedVersion({ commit }, version) {
		commit(SET_EMBED_VERSION, version);
	},
	setStorefrontStatus({ commit }, status) {
		commit(SET_STOREFRONT_STATUS, status);
	},
	setLogoData({ commit }, logoData) {
		commit(SET_LOGO_DATA, logoData);
	},
	setBillingsCount({ commit }, billingsCount) {
		commit(SET_BILLINGS_COUNT, billingsCount);
	},
	setBillingsDueCount({ commit }, billingsDueCount) {
		commit(SET_BILLINGS_DUE_COUNT, billingsDueCount);
	},
	setBlacklistedProductIds({ commit }, blacklistedProductIds) {
		commit(SET_BLACKLISTED_PRDOUCT_IDS, blacklistedProductIds);
	},
	setGoogleAnalyticsKey({ commit }, googleAnalyticsKey) {
		commit(SET_GOOGLE_ANALYTICS_KEY, googleAnalyticsKey);
	},
	setMetaPixels({ commit }, metaPixels) {
		commit(SET_META_PIXELS, metaPixels);
	},
	setLimitedStockProductIds({ commit }, limitedProductIds) {
		commit(SET_LIMITED_STOCK_PRODUCTS_IDS, limitedProductIds);
	},
	setRangeStockCheckedProductsCount({ commit }, rangeStockCheckedProductsCount) {
		commit(SET_RANGE_STOCK_CHECKED_PRODUCTS_COUNT, rangeStockCheckedProductsCount);
	},
	setStockCheckedProductsCount({ commit }, stockCheckedProductsCount) {
		commit(SET_STOCK_CHECKED_PRODUCTS_COUNT, stockCheckedProductsCount);
	},
	setCancelledSubmissionIds({ commit }, cancelledProductIds) {
		commit(SET_CANCELLED_SUBMISSIONS_IDS, cancelledProductIds);
	},
	setFullWidth({ commit }, isFullWidth) {
		commit(SET_FULL_WIDTH, isFullWidth);
	},
	setCustomDomains({ commit }, domains) {
		commit(SET_CUSTOM_DOMAINS, domains);
	},
	setDefaultResellerLimit({ commit }, limit) {
		commit(SET_DEFAULT_RESELLER_LIMIT, limit);
	},
	toggleSidebar({ commit, state }) {
		commit('setToggleSidebar', !state.isSidebarShow);
	},
	closeSidebarMobile({ commit, state }) {
		if (isMobile() && state.isSidebarShow) {
			commit('setToggleSidebar', false);
		}
	},
};

const getters = {
	capabilities: state => state.capabilities,
	commission: state => state.commission,
	dailyStatistic: state => state.dailyStatistic,
	user: state => state.user,
	settings: state => state.settings,
	isFetchingUser: state => state.isFetchingUser,
	// locale: state => state.locale,
	locale: state => (state.user && state.user.locale ? state.user.locale : 'en'),
	currency: state => (state.user ? state.user.currency : defaultCurrency),
	bankAccounts: state => (state.user && state.user.bank_accounts ? state.user.bank_accounts : []),
	identityCard: state => (state.user && state.user.identity ? state.user.identity : userIdentity),
	ordersColumns: state => (state.user && state.user.orders_columns ? state.user.orders_columns : []),
	productsColumns: state => (state.user && state.user.products_columns ? state.user.products_columns : []),
	features: state => (state.user && state.user.features ? state.user.features : []),
	currencySymbol: state => getCurrencySymbol(state.currency),
	isLoggedIn: state => state.isLoggedIn,
	isOoLoggedIn: state => state.isOoLoggedIn,
	loginError: state => state.loginError,
	pending: state => state.pending,
	announcements: state => state.announcements,
	isRightbarVisible: state => state.isRightbarVisible,
	isHasUsername: state => state.user && state.user.username !== '',
	isHasStoreAddress: (state) => {
		let hasStoreAddress = false;
		if (state.user
			&& state.user.store?.address
			&& state.user.store?.address !== ''
			&& state.user.store?.shipping?.origin?.subdistrict
			&& state.user.store?.shipping?.origin?.subdistrict?.id !== 0
			&& state.user.store?.shipping?.origin?.address !== ''
		) {
			hasStoreAddress = true;
		}
		return hasStoreAddress;
	},
	isHasStoreAddressDetail: (state) => {
		let hasStoreAddress = false;
		if (state.user
			&& state.user.store?.address_detail?.subdistrict_id
			&& state.user.store?.address_detail?.subdistrict_id !== 0
			&& state.user.store?.address_detail?.city
			&& state.user.store?.address_detail?.city_id !== 0
		) {
			hasStoreAddress = true;
		}
		return hasStoreAddress;
	},
	isHasStoreLocation: (state) => {
		let hasStoreLocation = false;
		if (state.user
			&& typeof state.user.store?.location?.lat !== 'undefined'
			&& state.user.store?.location?.lat !== ''
			&& typeof state.user.store?.location?.lng !== 'undefined'
			&& state.user.store?.location?.lng !== ''
			&& typeof state.user.store?.warehouse_photo !== 'undefined'
			&& state.user.store?.warehouse_photo !== ''
			&& typeof state.user.store?.warehouse_photo_with_owner !== 'undefined'
			&& state.user.store?.warehouse_photo_with_owner !== ''
		) {
			hasStoreLocation = true;
		}
		return hasStoreLocation;
	},
	isHasBankAccounts: state => state.user && state.user.bank_accounts && state.user.bank_accounts.length > 0,
	isValidIdentityCard: state => state.user && (state.user.identity !== undefined && state.user.identity.status === 'approved'),
	isAdmin: state => state.user && state.user.is_admin,
	// isSupport: state => state.user && isSupport(state.user._id),
	isSupport: state => state.user && state.user.is_support,
	isLogisticSupport: state => state.user && isLogisticSupport(state.user._id),
	isOwner: state => state.user && state.user.role === 'owner',
	isSupplier: state => state.user && state.user.owner_type === 'supplier',
	isOwnerAdmin: state => state.user && state.user.role === 'owner_admin',
	isOwnerShipper: state => state.user && state.user.role === 'owner_shipper',
	isDropshipper: state => state.user && state.user.owner_type === 'dropshipper',
	isRoleAdmin: state => state.user && state.user.role === 'admin',
	isRoleSuperAdmin: state => state.user && state.user.role === 'superadmin',
	isRoleFinance: state => state.user && state.user.role === 'finance',
	isPasswordEmpty: state => state.user && state.user?.is_password_empty === true,
	isAuthWithOO: state => state.user && state.user?.source_type === 'orderonline',
	isTester: state => state.user && isTester(state.user._id),
	isUserCan: state => capability => state.user && state.user.capabilities.indexOf(capability) !== -1,
	isHasFeature: state => feature => state.user
		&& state.user.features
		&& state.user.features.indexOf(feature) !== -1,
	isMenuActive: state => (menuName) => {
		const isActive = state.location.to.path === menuName;
		return isActive;
	},
	isNewPlan: state => state.user && state.user.package && newPlans.includes(state.user.package),
	store: state => (state.user ? state.user.store : defaultStore),
	overview: state => state.overview,
	followUpConversionStatistic: state => state.followUpConversionStatistic,
	trackingStatistic: state => state.trackingStatistic,
	transactionChartOptions: state => state.transactionChartOptions,
	commissionChartOptions: state => state.commissionChartOptions,
	revenueChartOptions: state => state.revenueChartOptions,
	customerChartOptions: state => state.customerChartOptions,
	profitableProducts: state => state.profitableProducts,
	highDemandProducts: state => state.highDemandProducts,
	highDemandProductsPagination: state => state.highDemandProductsPagination,
	isShowAllHighDemandProduct: state => state.isShowAllHighDemandProduct,
	highConvertingProducts: state => state.highConvertingProducts,
	transactionChartData: state => state.transactionChartData,
	commissionChartData: state => state.commissionChartData,
	revenueChartData: state => state.revenueChartData,
	customerChartData: state => state.customerChartData,
	defaultShipping: state => (state.user && state.user?.store?.shipping ? state.user.store.shipping : false),
	pixelIds: state => (state.user && state.user.pixel_ids ? state.user.pixel_ids : []),
	pixelEvents: state => state.pixelEvents,
	gtmIds: state => (state.user && state.user.gtm_ids ? state.user.gtm_ids : []),
	presetRangeLabel: state => state.presetRangeLabel,
	presetLifetime: (state) => {
		const n = new Date();
		const startDate = dayjs(
			state.user.created_at,
			'YYYY-MM-DD HH:mm:ss',
		).toDate();
		const endDate = new Date(
			n.getFullYear(),
			n.getMonth(),
			n.getDate(),
			23,
			59,
		);
		return {
			label: state.presetRangeLabel[state.locale].lifetime,
			active: false,
			dateRange: {
				start: startDate,
				end: endDate,
			},
		};
	},
	presetYesterday: (state) => {
		const n = new Date();
		const startDate = new Date(
			n.getFullYear(),
			n.getMonth(),
			n.getDate() - 1,
			0,
			0,
			1,
		);
		const endDate = new Date(
			n.getFullYear(),
			n.getMonth(),
			n.getDate() - 1,
			23,
			59,
			59,
		);
		return {
			label: state.presetRangeLabel[state.locale].yesterday,
			active: false,
			dateRange: {
				start: startDate,
				end: endDate,
			},
		};
	},
	presetToday(state) {
		const n = new Date();
		const startDate = new Date(
			n.getFullYear(),
			n.getMonth(),
			n.getDate(),
			0,
			0,
			1,
		);
		const endDate = new Date(
			n.getFullYear(),
			n.getMonth(),
			n.getDate(),
			23,
			59,
			59,
		);
		return {
			label: state.presetRangeLabel[state.locale].today,
			active: false,
			dateRange: {
				start: startDate,
				end: endDate,
			},
		};
	},
	presetThisMonth(state) {
		const n = new Date();
		const startMonth = new Date(n.getFullYear(), n.getMonth(), 1);
		const endMonth = new Date(n.getFullYear(), n.getMonth() + 1, 0);
		return {
			label: state.presetRangeLabel[state.locale].thisMonth,
			active: false,
			dateRange: {
				start: startMonth,
				end: endMonth,
			},
		};
	},
	presetLastMonth(state) {
		const n = new Date();
		const startMonth = new Date(n.getFullYear(), n.getMonth() - 1, 1);
		const endMonth = new Date(n.getFullYear(), n.getMonth(), 0);
		return {
			label: state.presetRangeLabel[state.locale].lastMonth,
			active: false,
			dateRange: {
				start: startMonth,
				end: endMonth,
			},
		};
	},
	presetLast7days(state) {
		const n = new Date();
		const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 6);
		const end = new Date(n.getFullYear(), n.getMonth(), n.getDate());
		return {
			label: state.presetRangeLabel[state.locale].lastSevenDays,
			active: false,
			dateRange: {
				start,
				end,
			},
		};
	},
	presetLast30days(state) {
		const label = state.presetRangeLabel[state.locale].lastThirtyDays;
		const n = new Date();
		const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 30);
		const end = new Date(n.getFullYear(), n.getMonth(), n.getDate());
		const preset = {
			label,
			active: false,
			dateRange: {
				start,
				end,
			},
			default: true,
		};
		return preset;
	},
	presetLast365days(state) {
		const label = state.presetRangeLabel[state.locale].last365Days;
		const n = new Date();
		const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 365);
		const end = new Date(n.getFullYear(), n.getMonth(), n.getDate());
		const preset = {
			label,
			active: false,
			dateRange: {
				start,
				end,
			},
			default: true,
		};
		return preset;
	},
	filterDatePresets: (state, getters) => {
		const presets = {
			// lifetime: getters.presetLifetime,
			yesterday: getters.presetYesterday,
			today: getters.presetToday,
			thisMonth: getters.presetThisMonth,
			lastMonth: getters.presetLastMonth,
			last7days: getters.presetLast7days,
			last30days: getters.presetLast30days,
			last365days: getters.presetLast365days,
		};
		return presets;
	},
	fbAdAccounts(state) {
		return state.fbAdAccounts;
	},
	fbCampaigns: state => state.fbCampaigns,
	fbCampaignNext: state => state.fbCampaignNext,
	isFetchingAdAccount: state => state.isFetchingAdAccount,
	isFetchingCampaigns: state => state.isFetchingCampaigns,
	notice: state => state.notice,
	noticePublics: state => state.noticePublics,
	embedVersion: state => state.embedVersion,
	isStorefrontActive: state => state.isStorefrontActive,
	appName: state => state.appName,
	appLogo: state => state.appLogo,
	appProject: state => state.appProject,
	ooWeb: state => state.ooWeb,
	ooApi: state => state.ooApi,
	logoData: state => state.logoData,
	billingsCount: state => state.billingsCount,
	billingsDueCount: state => state.billingsDueCount,
	blacklistedProductIds: state => state.blacklistedProductIds,
	googleAnalyticsKey: state => state.googleAnalyticsKey,
	metaPixels: state => state.metaPixels,
	limitedStockProductIds: state => state.limitedStockProductIds,
	rangeStockCheckedProductsCount: state => state.rangeStockCheckedProductsCount,
	stockCheckedProductsCount: state => state.stockCheckedProductsCount,
	cancelledSubmissionIds: state => state.cancelledSubmissionIds,
	// isExpired: (state) => { // disable user expired
	// 	let isExpired = false;
	// 	if (state.user) {
	// 		// Add 3 days grace period
	// 		const gracePeriod = 3; // days
	// 		const gracePeriodUnit = 'day';
	// 		const expiredDate = dayjs(state.user.expired_date);
	// 		const expiredDateWithGrace = expiredDate.add(
	// 			gracePeriod,
	// 			gracePeriodUnit,
	// 		);
	// 		isExpired = expiredDateWithGrace.isSameOrBefore(dayjs(), 'day');
	// 	}
	// 	return isExpired;
	// },
	isExpired: (state) => {
		let isExpired = false;
		const ownerType = state?.user?.owner_type ?? 'dropshipper';
		if (state.user && state.user.expired_date && ownerType === 'dropshipper') {
			const expiredTime = new Date(state.user.expired_date).getTime();
			const nowTime = new Date().getTime();
			isExpired = expiredTime < nowTime;
		} else if (state.user && !state.user.expired_date) {
			isExpired = true;
		}
		const isAdmin = state?.user?.is_admin ?? false;
		const isSupport = ownerType === 'support';
		if (isAdmin || isSupport) {
			isExpired = false;
		}
		return isExpired;
	},
	isFullWidth: state => state.isFullWidth,
	customDomains: state => state.customDomains,
	isSidebarShow: state => state.isSidebarShow,
	intercomHmac: state => state.intercomHmac,
	chatwhootHmac: state => state.chatwhootHmac,
	isGoogleRecaptchaEnabled: state => parseBoolean(state.isGoogleRecaptchaEnabled),
};

export default {
	state,
	getters,
	actions,
	mutations,
};
